import { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import { toast } from "react-toastify";
import {
  BoxTitle,
  BoxContainer,
  BoxHead,
  Underline,
} from "../../Components/Styles/PageStyles";
import { Form, Formik } from "formik";
import { useSelector } from "react-redux";
import { MdAccountBalance } from "react-icons/md";
import { FaCopy, FaTrash } from "react-icons/fa";
import NotFoundModel from "../../Components/NotFoundModel";
import AddBankDetails from "../../Components/BankDetails/AddBankDetails";
import moment from "moment";
import DeleteBank from "../../Components/BankDetails/DeleteBank";
import Table from "../../Components/BankDetails/Table";
import { AddBtn } from "../../Components/Styles/InputStyles";

const BankDetails = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const [addBankDetails, setAddBankDetails] = useState(false);
  const [isDeleteBank, setIsDeleteBank] = useState(false);
  const [apiData, setApiData] = useState([]);
  const [selectedData, setSelectedData] = useState(null);

  const fetchFunction = async () => {
    const response = await axios.get(`${Config.apiUrl}/bank/list`, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.isSuccess === true) {
      const bankAccountsOnly =
        res?.data?.filter((item) => item.type === 1) || [];
      setApiData(bankAccountsOnly);
    }
  };

  const getError = (res) => {
    toast.error("Failed to fetch bank details");
  };

  const {
    isLoading: isLoading,
    mutate: getListMutate,
    error,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  useEffect(() => {
    getListMutate();
  }, []);

  //------- Add Bank Account -------
  const AddBankAccountFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/bank/add`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const restorePaymentSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg);
      setAddBankDetails(false);
      getListMutate();
    } else {
      toast.success(data?.data?.msg);
    }
  };

  const restorePaymentError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: addBankAccountLoading, mutate: addBankAccountMutate } =
    useMutation(AddBankAccountFunction, {
      onSuccess: restorePaymentSuccess,
      onError: restorePaymentError,
    });
  const handleAddBankClose = () => {
    setAddBankDetails(false);
  };

  //------- Delete Bank -------
  const deleteBankFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/bank/remove`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };

  const onDeleteBankSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Bank account deleted successfully");
      getListMutate();
      setIsDeleteBank(false);
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onDeleteBankError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: deleteBankLoading, mutate: deleteBankMutate } =
    useMutation(deleteBankFunction, {
      onSuccess: onDeleteBankSuccess,
      onError: onDeleteBankError,
    });

  const handleDeleteModalClose = () => {
    setIsDeleteBank(false);
  };

  return (
    <BoxContainer>
      <BoxHead>
        <BoxTitle className="!mb-0 whitespace-nowrap">
          Bank Accounts
          <Underline />
        </BoxTitle>
        <Filters setAddBankDetails={setAddBankDetails} />
      </BoxHead>
      {(isLoading || isRefetching) && <Loading />}
      {/* <div className="my-10">
        {!error && !isLoading && apiData.length === 0 && (
          <EmptyState>
            <div className="text-center py-16">
              <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <MdAccountBalance className="text-gray-400 text-3xl" />
              </div>
              <h3 className="text-xl font-semibold text-gray-700 mb-3">
                No Bank Accounts Added
              </h3>
              <p className="text-gray-500 mb-8 max-w-md mx-auto">
                Add your first bank account to start managing your payment
                methods
              </p>
              <AddBtn
                onClick={() => setAddBankDetails(true)}
                className="mx-auto"
              >
                Add Bank Account
              </AddBtn>
            </div>
          </EmptyState>
        )}
      </div> */}
      {!error && !isLoading && (
        <TableWrapper>
          <Table
            apiData={error ? [] : apiData}
            setSelectedData={setSelectedData}
            setIsDeleteBank={setIsDeleteBank}
          />
          {error && !isLoading && <NotFoundModel />}
        </TableWrapper>
      )}
      {addBankDetails && (
        <>
          <div
            className={`${
              addBankDetails ? "flex" : "hidden"
            } h-screen w-screen bg-black/30 backdrop-blur-sm fixed inset-0 transition-all duration-400 ease-in-out z-50`}
          />
          <div
            className={`${
              addBankDetails ? "translate-x-0" : "translate-x-full"
            } fixed h-screen right-0 top-0 transition-all duration-300 ease-in-out bg-white flex items-start rounded-l-2xl overflow-hidden md:w-1/2 w-full lg:w-1/3 justify-start z-50`}
          >
            <AddBankDetails
              handleClose={handleAddBankClose}
              addBankAccountLoading={addBankAccountLoading}
              addBankAccountMutate={addBankAccountMutate}
            />
          </div>
        </>
      )}
      {isDeleteBank && (
        <DeleteBank
          deleteBankMutate={deleteBankMutate}
          deleteBankLoading={deleteBankLoading}
          setIsDeleteBank={setIsDeleteBank}
          selectedData={selectedData}
          handleClose={handleDeleteModalClose}
        />
      )}
    </BoxContainer>
  );
};

const Filters = ({ setAddBankDetails }) => {
  return (
    <Formik>
      <Form>
        <FilterContainer>
          <AddBtn
            type="button"
            onClick={() => {
              setAddBankDetails(true);
            }}
          >
            Add Bank Account
          </AddBtn>
        </FilterContainer>
      </Form>
    </Formik>
  );
};

const FilterContainer = tw.div`grid grid-cols-2 w-full gap-4 md:flex md:space-x-4 items-end mt-0 md:mt-0`;
const TableWrapper = tw.h1`my-10 border bg-white rounded-md `;
export default BankDetails;
